import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IConsultPrepaidDataFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/consultPrepaidData/ConsultPrepaidDataMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';

type Props = {
  onSubmit: any,
  meta: IConsultPrepaidDataFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const ConsultPrepaidDataFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          sm: 'repeat(1, 1fr)',
          md: 'repeat(1, 1fr)',
          lg: 'repeat(1, 1fr)',
        }}
        gap={5}
        mb={5}
      >
        {/* <CC.Box shadow={"md"}
         width={'100%'} p={5}>           */}
        <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>
            <CustomFormControl
              label={meta.idBank.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.idBank.name]}
            >
              <CustomTextInput
                meta={meta.idBank}
                register={register(meta.idBank.name)}
                hasError={errors[meta.idBank.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.nameBank.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.nameBank.name]}
            >
              <CustomTextInput
                meta={meta.nameBank}
                register={register(meta.nameBank.name)}
                hasError={errors[meta.nameBank.name]}
              />
            </CustomFormControl>

{/* ************************************************************************** */}

            <CustomFormControl
              label={meta.PAN.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.PAN.name]}
            >
              <CustomInputSelect
                meta={meta.PAN}
                register={register(meta.PAN.name)}
                hasError={errors[meta.PAN.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.seq.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.seq.name]}
            >
              <CustomTextInput
                meta={meta.seq}
                register={register(meta.seq.name)}
                hasError={errors[meta.seq.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.cardName.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardName.name]}
            >
              <CustomTextInput
                meta={meta.cardName}
                register={register(meta.cardName.name)}
                hasError={errors[meta.cardName.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.cardStatus.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardStatus.name]}
            >
              <CustomTextInput
                meta={meta.cardStatus}
                register={register(meta.cardStatus.name)}
                hasError={errors[meta.cardStatus.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.agencyId.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.agencyId.name]}
            >
              <CustomTextInput
                meta={meta.agencyId}
                register={register(meta.agencyId.name)}
                hasError={errors[meta.agencyId.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.agencyName.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.agencyName.name]}
            >
              <CustomTextInput
                meta={meta.agencyName}
                register={register(meta.agencyName.name)}
                hasError={errors[meta.agencyName.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.clientId.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.clientId.name]}
            >
              <CustomTextInput
                meta={meta.clientId}
                register={register(meta.clientId.name)}
                hasError={errors[meta.clientId.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.clientName.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.clientName.name]}
            >
              <CustomTextInput
                meta={meta.clientName}
                register={register(meta.clientName.name)}
                hasError={errors[meta.clientName.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.clientStatus.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.clientStatus.name]}
            >
              <CustomTextInput
                meta={meta.clientStatus}
                register={register(meta.clientStatus.name)}
                hasError={errors[meta.clientStatus.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.accountId.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.accountId.name]}
            >
              <CustomTextInput
                meta={meta.accountId}
                register={register(meta.accountId.name)}
                hasError={errors[meta.accountId.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.accountName.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.accountName.name]}
            >
              <CustomTextInput
                meta={meta.accountName}
                register={register(meta.accountName.name)}
                hasError={errors[meta.accountName.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.accountStatus.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.accountStatus.name]}
            >
              <CustomTextInput
                meta={meta.accountStatus}
                register={register(meta.accountStatus.name)}
                hasError={errors[meta.accountStatus.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.accountBalance.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.accountBalance.name]}
            >
              <CustomTextInput
                meta={meta.accountBalance}
                register={register(meta.accountBalance.name)}
                hasError={errors[meta.accountBalance.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.cardProductId.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardProductId.name]}
            >
              <CustomTextInput
                meta={meta.cardProductId}
                register={register(meta.cardProductId.name)}
                hasError={errors[meta.cardProductId.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.cardProductName.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardProductName.name]}
            >
              <CustomTextInput
                meta={meta.cardProductName}
                register={register(meta.cardProductName.name)}
                hasError={errors[meta.cardProductName.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.prepaidProductId.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.prepaidProductId.name]}
            >
              <CustomTextInput
                meta={meta.prepaidProductId}
                register={register(meta.prepaidProductId.name)}
                hasError={errors[meta.prepaidProductId.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.prepaidProductName.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.prepaidProductName.name]}
            >
              <CustomTextInput
                meta={meta.prepaidProductName}
                register={register(meta.prepaidProductName.name)}
                hasError={errors[meta.prepaidProductName.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.prepaidAppId.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.prepaidAppId.name]}
            >
              <CustomTextInput
                meta={meta.prepaidAppId}
                register={register(meta.prepaidAppId.name)}
                hasError={errors[meta.prepaidAppId.name]}
              />
            </CustomFormControl>


        </CC.SimpleGrid>
        {/* </CC.Box> */}

        

      </CC.Grid>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default ConsultPrepaidDataFormUI;
